// extracted by mini-css-extract-plugin
export default {"list":"List-module__list___TBgbD","list_without-shadow":"List-module__list_without-shadow___A0Rac"};